module.exports = __webpack_public_path__ + "static/media/Diya Martin.957c4e00.jpg";